import * as React from 'react'
import { useDispatch } from 'react-redux'

import { closeModal } from 'src/modules/modal'

import Button from 'src/components/atoms/common/Button'
import Img from 'src/components/molecules/common/ResponsiveImage'

import * as styles from 'src/components/molecules/Modal/ShopCampaign/style.module.styl'

interface IProps {
  children?: React.ReactNode
  options?: {
    resultID?: string
    callback?: Function
  }
}

const Component: React.FC<IProps> = (props) => {
  const dispatch = useDispatch()

  const close = () => {
    dispatch(closeModal())
    props.options?.callback && props.options.callback()
  }
  return (
    <div className={styles.shopcampaign}>
      <p className={styles.shopcampaign_title}>店頭連携<br />キャンペーン実施中</p>
      <p className={styles.shopcampaign_lead}>※キャンペーン対象店舗は東京都の21店舗に<br />限らせて頂きます。</p>
      <h2 className={styles.shopcampaign_img}>
        <Img src="shop/shop_modal.png" alt="" />
      </h2>
      <div className={styles.shopcampaign_description}>
        <p>
          診断結果で表示される2次元バーコードを<br />
          店頭にお持ち頂くと、商談がよりスムーズに<br />
          進みます。<br />
          ぜひ、ご参加ください。
        </p>
      </div>
      <div className={styles.shopcampaign_buttons}>
        <ul className={styles.buttons}>
          <li className={styles.buttons_item}>
            <div className={styles.button}>
              <Button className="closeModal" handleClick={close}>
                <span className={styles.button_text}>TOPに戻る</span>
                <span className={styles.button_icon}><span><i className={'cIcon-arrow1'} /></span></span>
              </Button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  )
}
export default Component
